import { isStructurallySafe } from './structural';

/**
 * Postal codes are not format-checked. Only structural garbage is rejected.
 * Empty string is valid (optional field). Country is accepted so callers can pass it.
 */
export function validateZipCode(zipCode: string, _country?: string): string | null {
  const trimmed = (zipCode ?? '').trim();
  if (trimmed.length === 0) {
    return null;
  }
  if (!isStructurallySafe(trimmed, 'postal')) {
    return 'Postal code is too long';
  }
  return null;
}
